import type { RouteRecordRaw } from "vue-router"

const Base = () => import("./components/Base.vue")
const Home = () => import("./views/Home.vue")
const Recipes = () => import("./views/Recipes.vue")
const GroceryList = () => import("./views/GroceryList.vue")
const RecipeForm = () => import("./components/RecipeForm.vue")
const ItemManager = () => import("./views/ItemManager.vue")
const Cooking = () => import("./views/Cooking.vue")

const routes: RouteRecordRaw[] = [
  {
    path: "/groceries",
    component: Base,
    children: [
      { path: "", component: Home, name: "groceries:home" },
      { path: "recipes/", component: Recipes, name: "groceries:recipes" },
      {
        path: "recipes/add/",
        component: RecipeForm,
        name: "groceries:add_recipe",
      },
      {
        path: "recipes/:id/",
        component: RecipeForm,
        name: "groceries:view_recipe",
      },
      {
        path: "grocery-list/",
        component: GroceryList,
        name: "groceries:grocery_list",
      },
      {
        path: "item-manager/",
        component: ItemManager,
        name: "groceries:item_manager",
      },
      { path: "cooking/", component: Cooking, name: "groceries:cooking" },
    ],
  },
]

export default routes
